import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { UnreadMessagesProvider } from "@/context/UnreadMessagesContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import StockPage from "@/pages/stock/StockPage";
import CaissePage from "@/pages/caisse/CaissePage";
import InterventionListPage from "@/pages/intervention/InterventionListPage";
import InterventionFormPage from "@/pages/intervention/InterventionFormPage";
import SAVListPage from "@/pages/sav/SAVListPage";
import SAVFormPage from "@/pages/sav/SAVFormPage";
import DevisListPage from "@/pages/devis/DevisListPage";
import DevisFormPage from "@/pages/devis/DevisFormPage";
import RepriseListPage from "@/pages/reprise/RepriseListPage";
import RepriseFormPage from "@/pages/reprise/RepriseFormPage";
import MessagesPage from "@/pages/communication/MessagesPage";
import HelpTicketsPage from "@/pages/communication/HelpTicketsPage";
import DepotOrdersPage from "@/pages/depot/DepotOrdersPage";
import DepotOrderDetailPage from "@/pages/depot/DepotOrderDetailPage";
import DepotLabelPage from "@/pages/depot/DepotLabelPage";
import DepotRepriseLabelPage from "@/pages/depot/DepotRepriseLabelPage";
import DepotCasiersPage from "@/pages/depot/DepotCasiersPage";
import DepotCsvListPage from "@/pages/depot/DepotCsvListPage";
import DepotCsvDetailPage from "@/pages/depot/DepotCsvDetailPage";
import CommandeListPage from "@/pages/commande/CommandeListPage";
import CommandeDetailPage from "@/pages/commande/CommandeDetailPage";
import AdminPage from "@/pages/admin/AdminPage";
import PersonnelPage from "@/pages/personnel/PersonnelPage";
import ClientListPage from "@/pages/clients/ClientListPage";
import ClientDetailPage from "@/pages/clients/ClientDetailPage";
import StatistiquesPage from "@/pages/stats/StatistiquesPage";
import MonPointagePage from "@/pages/personnel/MonPointagePage";
import ProfilPage from "@/pages/profil/ProfilPage";
import PublicSuiviPage from "@/pages/public/PublicSuiviPage";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
          <UnreadMessagesProvider>
            <Toaster position="top-right" />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/suivi/:token" element={<PublicSuiviPage />} />
              <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/stock" element={<ProtectedRoute><StockPage /></ProtectedRoute>} />
              <Route path="/caisse" element={<ProtectedRoute><CaissePage /></ProtectedRoute>} />
              <Route path="/interventions" element={<ProtectedRoute requireModule="intervention"><InterventionListPage /></ProtectedRoute>} />
              <Route path="/interventions/:id" element={<ProtectedRoute requireModule="intervention"><InterventionFormPage /></ProtectedRoute>} />
              <Route path="/sav" element={<ProtectedRoute requireModule="sav"><SAVListPage /></ProtectedRoute>} />
              <Route path="/sav/:id" element={<ProtectedRoute requireModule="sav"><SAVFormPage /></ProtectedRoute>} />
              <Route path="/devis" element={<ProtectedRoute requireModule="devis"><DevisListPage /></ProtectedRoute>} />
              <Route path="/devis/:id" element={<ProtectedRoute requireModule="devis"><DevisFormPage /></ProtectedRoute>} />
              <Route path="/reprises" element={<ProtectedRoute requireModule="reprise"><RepriseListPage /></ProtectedRoute>} />
              <Route path="/reprises/:id" element={<ProtectedRoute requireModule="reprise"><RepriseFormPage /></ProtectedRoute>} />
              <Route path="/communication" element={<ProtectedRoute requireModule="communication"><MessagesPage /></ProtectedRoute>} />
              <Route path="/communication/tickets" element={<ProtectedRoute requireModule="communication"><HelpTicketsPage /></ProtectedRoute>} />
              <Route path="/depot" element={<ProtectedRoute requireModule="depot" requirePermission="depot"><DepotOrdersPage /></ProtectedRoute>} />
              <Route path="/depot/etiquette" element={<ProtectedRoute requireModule="depot" requirePermission="depot"><DepotLabelPage /></ProtectedRoute>} />
              <Route path="/depot/etiquette-reprise" element={<ProtectedRoute requireModule="depot" requirePermission="depot"><DepotRepriseLabelPage /></ProtectedRoute>} />
              <Route path="/depot/casiers" element={<ProtectedRoute requireModule="depot" requirePermission="depot"><DepotCasiersPage /></ProtectedRoute>} />
              <Route path="/depot/inventaire" element={<ProtectedRoute requireModule="depot" requirePermission="depot"><DepotCsvListPage /></ProtectedRoute>} />
              <Route path="/depot/inventaire/:id" element={<ProtectedRoute requireModule="depot" requirePermission="depot"><DepotCsvDetailPage /></ProtectedRoute>} />
              <Route path="/depot/:id" element={<ProtectedRoute requireModule="depot" requirePermission="depot"><DepotOrderDetailPage /></ProtectedRoute>} />
              <Route path="/commandes" element={<ProtectedRoute requireModule="commande"><CommandeListPage /></ProtectedRoute>} />
              <Route path="/commandes/:id" element={<ProtectedRoute requireModule="commande"><CommandeDetailPage /></ProtectedRoute>} />
              <Route path="/clients" element={<ProtectedRoute requireModule="client"><ClientListPage /></ProtectedRoute>} />
              <Route path="/clients/:id" element={<ProtectedRoute requireModule="client"><ClientDetailPage /></ProtectedRoute>} />
              <Route path="/statistiques" element={<ProtectedRoute requireModule="statistiques"><StatistiquesPage /></ProtectedRoute>} />
              <Route path="/mon-pointage" element={<ProtectedRoute><MonPointagePage /></ProtectedRoute>} />
              <Route path="/profil" element={<ProtectedRoute><ProfilPage /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
              <Route path="/personnel" element={<ProtectedRoute requireModule="personnel" requirePermission="personnel" requireAction="access"><PersonnelPage /></ProtectedRoute>} />
              <Route path="/admin/users" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
              <Route path="/admin/shops" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
            </Routes>
          </UnreadMessagesProvider>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
